<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-building fa-fw"></i>Minhas Empresas
          </h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <div class="col-lg-12">
      <div v-if="addButton.seeForm">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="active">
            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
              <i class="fa fa-user fa-fw"></i> Dados Cadastrais</a
            >
          </li>
          <li role="presentation">
            <a
              ref="activitiesLink"
              href="#activities"
              aria-controls="profile"
              role="tab"
              data-toggle="tab"
            >
              <i class="fa fa-rocket fa-fw"></i>
              Atividades</a
            >
          </li>
        </ul>

        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="home">
            <form role="form" @submit.stop.prevent="send">
              <input v-model="person.id" type="hidden" />
              <h2><i class="fa fa-home fa-fw"></i>Empresa</h2>
              <div class="form-row">
                <div class="col-md-4 mb-3">
                  <label>ID</label>
                  <input v-model="person.id" class="form-control" disabled />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Nome (Razão Social)</label>
                  <input
                    v-model="person.name"
                    class="form-control"
                    placeholder="Nome"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Nome Fantasia</label>
                  <input
                    v-model="person.corporateName"
                    class="form-control"
                    placeholder="Nome fantasia"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>CNPJ</label>
                  <input
                    v-model="person.cnpj"
                    class="form-control"
                    v-mask="'##.###.###/####-###'"
                    placeholder="XX.XXX.XXX/XXXX-XXX"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Inscrição Estadual</label>
                  <input
                    v-model="person.stateRegistration"
                    class="form-control"
                    placeholder="Inscrição Estadual"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Endereço da Sede - Logradouro</label>
                  <input
                    v-model="person.primaryAddress"
                    class="form-control"
                    placeholder="Endereço"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Nº</label>
                  <input
                    v-model="person.primaryAddressNumber"
                    class="form-control"
                    placeholder="Número"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Bairro</label>
                  <input
                    v-model="person.primaryAdressDistrict"
                    class="form-control"
                    placeholder="Bairro"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Complemento</label>
                  <input
                    v-model="person.primaryAdressComplement"
                    class="form-control"
                    placeholder="Complemento"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>CEP</label>
                  <input
                    v-model="person.primaryPostalCode"
                    class="form-control"
                    v-mask="'##.###-###'"
                    placeholder="CEP"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Cidade</label>
                  <input
                    v-model="person.municipalRegistration"
                    class="form-control"
                    placeholder="Cidade"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>UF</label>
                  <input
                    v-model="person.primaryAdressState"
                    class="form-control"
                    placeholder="UF"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Telefone</label>
                  <input
                    v-model="person.primaryPhone"
                    class="form-control"
                    v-mask="'(##) ####-####'"
                    placeholder="(DD) XXXX-XXXX"
                  />
                </div>
                <div class="col-md-8 mb-3">
                  <label>Email</label>
                  <input
                    v-model="person.primaryEmail"
                    class="form-control"
                    placeholder="email"
                  />
                  <p
                    v-if="!validarEmail(person.primaryEmail)"
                    style="color: red"
                  >
                    <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                  </p>
                </div>
              </div>
              <p>&nbsp</p>
              <!-- 
              <h2><i class="fa fa-database fa-fw"></i> Dados Filial</h2>
              <div class="form-row">
                <div class="col-md-8 mb-3">
                  <label>Endereço da Filial</label>
                  <input
                    v-model="person.secundaryAddress"
                    class="form-control"
                    placeholder="Endereço da filial"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Nº</label>
                  <input
                    v-model="person.secundaryAddressNumber"
                    class="form-control"
                    placeholder="Número da filial"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Bairro</label>
                  <input
                    v-model="person.secundaryAdressDistrict"
                    class="form-control"
                    placeholder="Bairro da filial"
                  />
                </div>
                <div class="col-md-8 mb-3">
                  <label>Complemento</label>
                  <input
                    v-model="person.secundaryAdressComplement"
                    class="form-control"
                    placeholder="Complemento da filial"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>CEP</label>
                  <input
                    v-model="person.secundaryPostalCode"
                    class="form-control"
                    v-mask="'##.###-###'"
                    placeholder="CEP da filial"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Cidade</label>
                  <input class="form-control" v-model="person.secundaryMunicipalRegister" placeholder="Cidade da filial" />
                </div>
                <div class="col-md-4 mb-3">
                  <label>UF</label>
                  <input
                    v-model="person.secundaryAdressState"
                    class="form-control"
                    placeholder="UF da filial"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <label>Telefone</label>
                  <input
                    v-model="person.secundaryPhone"
                    class="form-control"
                    v-mask="'(###) ####-####'"
                    placeholder="(DDD) XXXX-XXXX da filial"
                  />
                </div>
                <div class="col-md-8 mb-3">
                  <label>Email</label>
                  <input
                    v-model="person.secundaryEmail"
                    class="form-control"
                    placeholder="email da filial"
                  />
                  <p
                    v-if="!validarEmail(person.secundaryEmail)"
                    style="color: red"
                  >
                    <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                  </p>
                </div>
              </div>
              -->
              <p>&nbsp</p>
              <h2><i class="fa fa-users"></i> Responsáveis</h2>
              <div class="form-row">
                <div class="col-md-6 mb-3">
                  <label>Representante Legal</label>
                  <input
                    v-model="person.legalRepresentativeName"
                    class="form-control"
                    placeholder="Nome"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>CPF</label>
                  <input
                    v-model="person.legalRepresentativeCPF"
                    class="form-control"
                    v-mask="'###.###.###-##'"
                    placeholder="CPF"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>Cargo</label>
                  <input
                    v-model="person.legalRepresentativeCargo"
                    class="form-control"
                    placeholder="Cargo"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>Telefone Cel</label>
                  <input
                    v-model="person.legalRepresentativePhone"
                    class="form-control"
                    v-mask="'(##) # ####-####'"
                    placeholder="(DD) X XXXX-XXXX"
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label>Email</label>
                  <input
                    v-model="person.legalRepresentativeEmail"
                    class="form-control"
                    placeholder="email"
                  />
                  <p
                    v-if="!validarEmail(person.legalRepresentativeEmail)"
                    style="color: red"
                  >
                    <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                  </p>
                </div>
                <div class="col-md-6 mb-3">
                  <label>Representante Técnico</label>
                  <input
                    v-model="person.tecnicalRepresentativeName"
                    class="form-control"
                    placeholder="Nome"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>CPF</label>
                  <input
                    v-model="person.tecnicalRepresentativeCPF"
                    class="form-control"
                    v-mask="'###.###.###-##'"
                    placeholder="CPF"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>Cargo</label>
                  <input
                    v-model="person.tecnicalRepresentativeCargo"
                    class="form-control"
                    placeholder="Cargo"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>Telefone Cel</label>
                  <input
                    v-model="person.tecnicalRepresentativePhone"
                    class="form-control"
                    v-mask="'(##) # ####-####'"
                    placeholder="(DD) XXXXX-XXXX"
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label>Email</label>
                  <input
                    v-model="person.tecnicalRepresentativeEmail"
                    class="form-control"
                    placeholder="email"
                  />
                  <p
                    v-if="!validarEmail(person.tecnicalRepresentativeEmail)"
                    style="color: red"
                  >
                    <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                  </p>
                </div>
              </div>
              <p>&nbsp</p>

              <h2><i class="fa fa-pencil fa-fw"></i> Termos de Uso</h2>

              <div class="panel panel-default">
                <div class="panel-heading">DECLARAÇÃO DE RESPONSABILIDADE</div>
                <div class="panel-body">
                  <p>
                    <b v-if="person.name">{{ person.name }}</b
                    ><b v-else>{{ person.legalRepresentativeName }}</b
                    >, <b v-if="person.cnpj">{{ person.cnpj }}</b
                    ><b v-else>{{ person.legalRepresentativeCPF }}</b> declara
                    ter pleno conhecimento e ser total responsável pelo estrito
                    cumprimento da legislação ambiental e da segurança do
                    trabalho e pela adoção de todos os procedimentos de saúde,
                    de segurança, de meio ambiente e operacionais dentro da área
                    do Porto Organizado do Itaqui, e que, portanto, assume a
                    responsabilidade, na esfera cível ou criminal, por eventuais
                    incidentes que vierem a decorrer de descumprimento do
                    ordenamento jurídico vigente.
                  </p>
                </div>
              </div>

              <div class="panel panel-default">
                <div class="panel-heading">
                  TERMO DE CONSENTIMENTO PARA TRATAMENTO DE DADOS PESSOAIS
                </div>
                <div class="panel-body">
                  <p>
                    (Este termo de consentimento fundamenta-se no art. 7º, I da
                    Lei n.º 13.709, de 2018 e servirá de base legal para a
                    coleta de dado pessoal por ocasião do cadastro no sistema
                    Passport e inserção de informações no site do Porto do
                    Itaqui)
                  </p>

                  <p>
                    Em observância à Lei n.º 13.709, de 2018 (Lei Geral de
                    Proteção de Dados), manifesto-me de forma livre, expressa,
                    consciente e informada para AUTORIZAR a Empresa Maranhense
                    de Administração Portuária (EMAP) a realizar o tratamento de
                    meus dados pessoais para as finalidades e de acordo com as
                    condições aqui estabelecidas.
                  </p>

                  <p>
                    1. Finalidade do Tratamento. Os dados pessoais serão
                    coletados pela Gerência de Logística da EMAP e serão
                    utilizados, exclusivamente, para as seguintes finalidades:
                    coleta e inserção de dados (nome da empresa, endereço,
                    telefone e e-mail) no site do Porto do Itaqui.
                  </p>

                  <p>
                    2. Prazo de Retenção. Os dados pessoais coletados serão
                    armazenados em banco de dados virtual da EMAP e divulgados
                    no site do Porto do Itaqui pelo prazo de 03 anos.
                  </p>

                  <p>
                    3. Revogação do Consentimento. Este termo de consentimento
                    poderá ser revogado pelo Titular, mediante solicitação
                    enviada pelo Canal de Atendimento de Privacidade de dados,
                    no endereço https://www.portodoitaqui.ma.gov.br/contato,
                    podendo exercer os demais direitos previstos no Art. 17 e
                    seguintes da LGPD, através do mesmo Canal.
                  </p>
                </div>
              </div>

              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="person.confirmation"
                  v-bind:id="person.confirmation"
                />
                <label class="form-check-label" for="check-hab"> Ciente </label>
              </div>
              <p>&nbsp</p>
              <div class="row">
                <div class="col-12">
                  <button type="submit" class="btn btn-block btn-info">
                    Salvar
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div role="tabpanel" class="tab-pane" id="activities">
            <div class="container">
              <br />
              <div class="panel-group" id="accordion">
                <div
                  class="panel panel-default"
                  v-for="atividade in activities"
                  :key="atividade.id"
                >
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a
                        class="accordion-toggle"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        v-bind:href="'#atividade' + atividade.id"
                        @click="loadAccreditation(atividade)"
                      >
                        {{ atividade.name }}

                        <small v-if="atividade.accreditation">
                          <div class="label label-info">
                            {{
                              atividade.accreditation.state || "em andamento"
                            }}
                          </div>
                          <a
                            class="btn btn-info btn-xs"
                            v-if="atividade.accreditation.state == 'liberado'"
                            @click.prevent.stop="
                              downloadCertificate(person.id, atividade.id)
                            "
                            style="margin: 5px"
                          >
                            <i class="fa fa-download fa-fw"></i>
                            download certificado
                          </a>
                        </small>
                      </a>
                    </h4>
                  </div>
                  <div
                    :id="'atividade' + atividade.id"
                    class="panel-collapse collapse"
                  >
                    <div class="panel-body">
                      <h4><i class="fa fa-book fa-fw"></i> Descrição</h4>

                      <p>
                        <b>{{ atividade.description }} </b>
                      </p>

                      <form
                        @submit.stop.prevent="
                          sendAccreditation(person, atividade)
                        "
                      >
                        <input type="hidden" v-model="accreditation.id" />
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Nº do certificado</label>
                              <input
                                class="form-control"
                                v-model="numeroProcesso"
                                disabled
                              />
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Descrição Detalhada: Descrever a atividade que será realizada na área primária conforme consta na Comprovação de Inscrição de Situação Cadastral (CNPJ)</label>
                          <textarea
                            maxlength="250"
                            class="form-control"
                            v-model="accreditation.details"
                            required="required"
                          >Informe aqui detalhes sobre a sua atividade</textarea>
                        </div>

                        <div class="form-group">
                          <button
                            @click="alert = true"
                            type="submit"
                            class="btn btn-block btn-info"
                          >
                            <i class="fa fa-send fa-fw"></i> Salvar e começar a enviar documentos
                          </button>
                        </div>
                      </form>
                      <div v-if="alert" class="alert alert-success col-lg-12">
                        <i class="fa fa-info fa-fw"></i>
                        <span>
                          <strong>
                            Sua solicitação de credenciamento foi solicitada com
                            sucesso, por favor envie todos os documentos
                            necessários para a análise!
                          </strong>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            aria-label="Close"
                            @click="alert = null"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </span>
                      </div>
                      <hr />

                      <div v-if="acreditationExists(accreditation.id)">
                        <h3>
                          <i class="fa fa-upload fa-fw"></i> Envie os documentos
                        </h3>

                        <div
                          class="panel panel-info"
                          v-for="item in itens"
                          :key="item.id"
                        >
                          <div class="panel-heading">
                            <div class="panel-title">
                              <i class="fa fa-file-o"></i> {{ item.rule.name }}
                            </div>
                          </div>

                          <div class="panel-body">
                            <form class="form-inline">
                              <div class="form-group col-md-6">
                                <file-pond
                                  name="file"
                                  ref="pond"
                                  label-idle="Faça upload do documento aqui"
                                  v-bind:allow-multiple="false"
                                  accepted-file-types="application/pdf, application/zip"
                                  v-bind:server="
                                    loadServerData(
                                      accreditation || null,
                                      person.id,
                                      atividade,
                                      item.rule.id,
                                      item.rule.filename
                                    )
                                  "
                                />
                              </div>
                              <div class="form-group">
                                <label>Validade</label>
                                <input
                                  type="text"
                                  class="form-control input-sm"
                                  size="10"
                                  v-mask="'##/##/####'"
                                  :value="dataFormatada(item.validity)"
                                  placeholder="DD/MM/AAAA"
                                  name="validade"
                                  id="validade"
                                  @blur="
                                    sendValidade(
                                      $event,
                                      accreditation.id,
                                      item.rule.id
                                    )
                                  "
                                />
                              </div>

                              <div
                                class="btn-group btn-group-xs pull-right"
                                role="group"
                              >
                                <a
                                  type="button"
                                  class="btn"
                                  :class="getState(item.state)"
                                >
                                  <i
                                    class="fa"
                                    :class="getIcon(item.state)"
                                  ></i>
                                  {{ item.state }}
                                </a>
                                <a
                                  class="btn btn-primary"
                                  @click="
                                    download(
                                      person.id,
                                      atividade.id,
                                      item.rule.id,
                                      item.rule.filename
                                    )
                                  "
                                >
                                  <i class="fa fa-download fa-fw"></i> download
                                </a>
                                <a
                                  class="btn btn-warning"
                                  @click="
                                    preview(
                                      person.id,
                                      atividade.id,
                                      item.rule.id,
                                      item.rule.filename
                                    )
                                  "
                                >
                                  <i class="fa fa-file-o fa-fw"></i> visualizar
                                </a>
                                <a
                                  type="button"
                                  class="btn dropdown-toggle btn-info"
                                  data-toggle="dropdown"
                                >
                                  Informações
                                  <span class="caret"></span>
                                </a>
                                <ul class="dropdown-menu">
                                  <li>
                                    <a> Setor: {{ item.rule.sectorName }} </a>
                                  </li>
                                  <li>
                                    <a>
                                      Telefone: {{ item.rule.sectorPhone }}
                                    </a>
                                  </li>
                                  <li>
                                    <a> E-mail: {{ item.rule.sectorEmail }} </a>
                                  </li>
                                </ul>
                              </div>
                            </form>
                            <span
                              v-if="
                                item.refusedReason && item.state == 'recusado'
                              "
                            >
                              <br />
                              <br />
                              <div class="alert alert-danger">
                                <i class="fa fa-times"></i>
                                <b>Motivo da recusa</b> <br />
                                {{ item.refusedReason }}
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="alert alert-warning label-lg">
                          <i class="fa fa-exclamation fa-fw"></i>
                          Cadastre as informações acima para em seguida enviar
                          os documentos
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
    </div>
    <div class="row">
      <div v-if="persons.length > 0">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="person in persons"
              :key="person.id"
              @mouseover="showByIndex = person.id"
              @mouseout="showByIndex = null"
            >
              <td>{{ person.id }}</td>
              <td>{{ person.name }}</td>
              <td>{{ person.legalRepresentativeEmail }}</td>
              <td>{{ person.primaryEmail }}</td>
              <td>{{ person.primaryPhone }}</td>
              <td>
                <a
                  @click.stop="edit(person.id)"
                  v-visible="showByIndex === person.id"
                  class="btn btn-sm btn-primary"
                  ><i class="fa fa-pencil fa-fw"></i
                ></a>
                <!-- <a
                  @click="
                    showModal = 1;
                    show = person.id;
                  "
                  v-visible="showByIndex === person.id"
                  class="btn btn-sm btn-danger"
                  ><i class="fa fa-trash fa-fw"></i
                ></a> REMOVENDO BOTÃO DE DELETE PARA USUÁRIOS EXTERNOS-->
                <Modal v-if="showModal === 1 && show === person.id">
                  <i
                    slot="close"
                    @click="
                      showModal = null;
                      yes = null;
                    "
                    >&times;</i
                  >
                  <h2 slot="header">
                    <i class="fa fa-times fa-fw"></i>Remover Empresa
                  </h2>
                  <div slot="body">
                    <h4>
                      Deseja realmente remover a empresa
                      <strong>{{ person.name }}?</strong>
                    </h4>
                  </div>
                  <div slot="footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="
                        yes = true;
                        showModal = null;
                      "
                      @click.stop="remove(person.id)"
                    >
                      Confirmar
                    </button>
                    <button
                      class="btn btn-default"
                      @click="
                        yes = null;
                        showModal = null;
                      "
                    >
                      fechar
                    </button>
                  </div>
                </Modal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Modal v-if="showModal === 2">
        <i slot="close" @click="showModal = null">&times;</i>
        <h2 slot="header">
          <i class="fa fa-times fa-fw"></i>Verifique os campos
        </h2>
        <div slot="body">
          <div
            v-for="texto in msg"
            :key="texto.indexOf"
            class="alert alert-warning alert-small"
          >
            {{ texto }}
          </div>
        </div>
        <div slot="footer">
          <button class="btn btn-default" @click="showModal = null">Ok</button>
        </div>
      </Modal>
      <Modal v-if="showModal === 3">
        <i slot="close" @click="showModal = null">&times;</i>
        <h2 slot="header">
          <i class="fa fa-exclamation-circle fa-fw"></i>Cadastro de Empresa
        </h2>
        <div slot="body">
          <div class="alert alert-success alert-small">
            <i class="fa fa-exclamation"></i>
            Empresa cadastrada! Agora falta associa-la a uma atividade.
          </div>
        </div>
        <div slot="footer">
          <button class="btn btn-default" @click="clickOnActivities()">Associar a uma atividade</button>
        </div>
      </Modal>
      <div v-else-if="!persons.length">
        <div class="row">
          <div class="col-md-12">
            <a
              class="btn btn-success btn-lg btn-block"
              @click="
                addButton.seeForm = !addButton.seeForm;
                person = {};
              "
            >
              <span v-if="addButton.seeForm">
                <i class="fa fa-search fa-fw"></i> Exibir Empresas
              </span>
              <span v-else>
                <i class="fa fa-plus fa-fw"></i> Cadastrar Empresa
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import vueFilePond, { setOptions } from "vue-filepond";

import ptBR from "filepond/locale/pt-br";
import "filepond/dist/filepond.css";
import { mask } from "vue-the-mask";
import Modal from "../../components/ui-elements/Modal.vue";
import lang from "../../mixins/pt-br";
import storage from "../../mixins/storage";
import stateMix from "../../mixins/state";
const FilePond = vueFilePond();
setOptions(ptBR);

export default {
  name: "MyPersons",
  directives: { mask },
  inject: ["loading"],
  components: { Modal, FilePond },
  data() {
    return {
      user: {},
      person: {},
      persons: [],
      activity: {},
      activities: [],
      accreditations: [],
      accreditation: {},
      itens: [],
      addButton: { seeForm: false },
      showByIndex: null,
      showModal: null,
      show: null,
      msg: null,
      yes: null,
      alert: null,
      files: [
        {
          source: "12345",
          options: {
            type: "local",
            file: {
              name: `${this.$http.defaults.baseURL}`,
              size: 3001025,
              type: "application/pdf",
            },
          },
        },
      ],
      server: {},
    };
  },
  computed: {
    numeroProcesso() {
      if (this.accreditation.id == undefined) {
        return "";
      }

      const date = new Date();
      const number = new String(this.accreditation.id).padStart(5, "0");
      this.accreditation.processNumber = `${number}/${date.getUTCFullYear()}`;
      return this.accreditation.processNumber;
    },
  },
  mounted() {
    this.$http
      .get("my-person")
      .then((response) => {
        this.loading.value = true;
        this.persons = response.data.content;

        this.$http
          .get("activity/available")
          .then((response) => {
            this.activities = response.data;
          })
          .catch((error) => console.log(error));
      })
      .finally(() => {
        setTimeout(() => (this.loading.value = false), 1000);
      });
  },
  methods: {
    downloadCertificate(personId, activityId) {
      this.$http
        .get(
          `/certificate/get-certificate-by-person-and-activity/${personId}/${activityId}`
        )
        .then((response) => {
          window
            .open(`/#/certificate/print/${response.data.id}`, "_blank")
            .focus();
        })
        .catch((error) => console.log(error));
    },
    getIcon(stateName) {
      return stateMix.methods.getIcon(stateName);
    },
    getState(stateName) {
      return stateMix.methods.getState(stateName);
    },
    dataFormatada(data) {
      return data ? new Date(data).toLocaleDateString("pt-BR") : "";
    },
    formatDate(dateString) {
      if (dateString) {
        return new Date(dateString).toLocaleDateString("pt-BR");
      } else {
        return "";
      }
    },
    acreditationExists(id) {
      return id;
    },
    sendValidade(event, accreditation, rule) {
      const data = event.target.value;
      const validity = data.split("/").reverse().join("-");

      this.$http
        .put(
          `/my-accreditation-itens/validity/${accreditation}/${rule}/${validity}`
        )
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => console.log(error));
    },
    download(person, activity, accreditation, filename) {
      const link = `${this.$http.defaults.baseURL}/public/credenciamentos/${person}/${activity}/${accreditation}/${filename}`;

      this.$http
        .get(link, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          const extension =
            response.headers["content-type"] == "application/zip"
              ? ".zip"
              : ".pdf";

          link.setAttribute("download", `${filename}${extension}`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    preview(person, activity, accreditation, filename) {
      const link = `${this.$http.defaults.baseURL}/public/credenciamentos/${person}/${activity}/${accreditation}/${filename}`;

      this.$http
        .get(link, { responseType: "blob" })
        .then((response) => {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((error) => console.log(error));
    },
    handleFilePondInit(person, atividade, rule, filename) {
      console.log(person, atividade, rule, filename);
    },
    loadServerData(accreditation, person, activity, rule, filename) {
      if (!this.accreditation) {
        return;
      }

      const customUrl = `/my-accreditation/upload/${accreditation.id}/${person}/${activity.id}/${rule}/${filename}`;

      return {
        url: this.$http.defaults.baseURL,
        process: {
          url: customUrl,
          method: "POST",
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${storage.methods.getToken()}`,
          },
          timeout: 250000,
          onload: () => {
            activity.accreditation = accreditation;
            this.loadAccreditation(activity);
          },
          onerror: null,
          ondata: null,
        },
      };
    },
    loadAccreditation(atividade) {
      if (atividade.accreditation) {
        this.loading.value = true;

        this.accreditation = atividade.accreditation;

        this.$http
          .get(`/my-accreditation-itens/all/${this.accreditation.id}`)
          .then((response) => {
            this.itens = response.data;
          })
          .catch((error) => console.log(error))
          .finally(() => setTimeout(() => (this.loading.value = false), 1000));
      } else {
        this.accreditation = {};
        this.itens = [];
      }
    },
    sendAccreditation(person, atividade) {
      this.accreditation.personId = person.id;
      this.accreditation.activityId = atividade.id;

      if (!this.accreditation.id) {
        this.$http
          .post("my-accreditation", this.accreditation)
          .then((response) => {
            this.accreditation = response.data;
            atividade.accreditation = response.data;
          })
          .finally(() => {
            this.loadAccreditation(atividade);
          })
          .catch((error) => console.log(error));
      } else {
        this.$http
          .put(`my-accreditation/${this.accreditation.id}`, this.accreditation)
          .then((response) => {
            this.accreditation = response.data;
            atividade.accreditation = response.data;
          })
          .finally(() => {
            this.loadAccreditation(atividade);
          })
          .catch((error) => console.log(error));
      }
    },
    send() {
      if(this.person.confirmation) {
          this.loading.value = true;
        if (this.person.id) {
          this.$http
            .put(`/my-person/${this.person.id}`, this.person)
            .then((response) => {
              this.persons = this.persons.filter(
                (item) => item.id != this.person.id
              );
              this.persons.push(response.data);
              this.showModal = 3;
            })
            .catch((error) => {
              if (error.response) {
                this.exibirErroValidacao(error.response.data);
              }
            });
          setTimeout(() => (this.loading.value = false), 1000);
        } else {
          this.$http
            .post("/my-person", this.person)
            .then((response) => {
              this.person = {};
              this.persons.push(response.data);
              this.showModal = 3;
              setTimeout(() => (this.loading.value = false), 1000);
            })
            .catch((error) => {
              if (error.response) {
                this.exibirErroValidacao(error.response.data);
              }
            });
          setTimeout(() => (this.loading.value = false), 1000);
        }
      }
      else {
        this.showModal = 2;
        const texto = ['Aceite os termos de uso antes de prosseguir'];
        this.msg = texto;
      }
    },
    edit(id) {
      this.loading.value = true;
      this.$http
        .get(`/my-person/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.person = response.data;

          this.$http
            .get(`/my-accreditation/all/${this.person.id}`)
            .then((response) => {
              this.accreditations = response.data;

              this.$forceUpdate();

              this.accreditations.forEach((item) => {
                this.activities.forEach((activity, index) => {
                  if (activity.id === item.activity.id) {
                    this.activities[index].accreditation = item;
                    return;
                  }
                });
              });
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          if (error.response) {
            this.exibirErroValidacao(error.response.data);
          }
        });
      setTimeout(() => (this.loading.value = false), 1000);
    },
    remove(id) {
      this.loading.value = true;
      const confirm = this.yes;

      if (confirm) {
        this.$http
          .delete(`/my-person/${id}`)
          .then((response) => {
            this.persons = this.persons.filter((item) => item.id != id);
          })
          .catch((error) => {
            if (error.response) {
              this.exibirErroValidacao(error.response.data);
            }
          });
      }
      setTimeout(() => (this.loading.value = false), 1000);
    },
    exibirErroValidacao(error) {
      const texto = error.reduce((acc, { campo, erro }) => {
        acc.push(`${lang.t(campo)} : ${erro}`);
        return acc;
      }, []);

      this.showModal = 2;
      this.msg = texto;
    },
    order() {
      this.activity.sort((a, b) => {
        if (a.order < b.order) {
          return -1;
        }
        if (a.order > b.order) {
          return 1;
        }
        return 0;
      });
    },
    validarEmail(email) {
      if (!email) {
        return true;
      }

      return /(.+)@(.+){2,}\.(.+){2,}/.test(email);
    },
    clickOnActivities() {
      this.$refs.activitiesLink.click();
      this.showModal = null;
    }
  },
};
</script>
<style scoped>
.accordion-toggle {
  text-decoration: none;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/MyPersons.vue